import { get, post, put, del, getAllSliders, activateSlider as activateSliderAPI, deactivateSlider as deactivateSliderAPI, deleteSlider as deleteSliderAPI, uploadSliderPicture as uploadSliderPictureAPI, createSlider as createSliderAPI } from './apiService';

const sliderService = {
  // Get all sliders
  getSliders: async () => {
    try {
      const response = await getAllSliders();
      return response.data || response;
    } catch (error) {
      console.error('Error fetching sliders:', error);
      throw error;
    }
  },

  // Create a new slider
  createSlider: async (sliderData) => {
    try {
      const response = await createSliderAPI(sliderData);
      return response.data || response;
    } catch (error) {
      console.error('Error creating slider:', error);
      throw error;
    }
  },

  // Update an existing slider
  updateSlider: async (sliderData) => {
    try {
      const response = await put('admin/updateslider', sliderData);
      return response.data || response;
    } catch (error) {
      console.error('Error updating slider:', error);
      throw error;
    }
  },

  // Delete a slider
  deleteSlider: async (sliderId) => {
    try {
      const response = await deleteSliderAPI(sliderId);
      return response.data || response;
    } catch (error) {
      console.error('Error deleting slider:', error);
      throw error;
    }
  },

  // Activate a slider
  activateSlider: async (sliderId) => {
    try {
      const response = await activateSliderAPI(sliderId);
      return response.data || response;
    } catch (error) {
      console.error('Error activating slider:', error);
      throw error;
    }
  },

  // Deactivate a slider
  deactivateSlider: async (sliderId) => {
    try {
      const response = await deactivateSliderAPI(sliderId);
      return response.data || response;
    } catch (error) {
      console.error('Error deactivating slider:', error);
      throw error;
    }
  },

  // Upload slider picture
  uploadSliderPicture: async (file) => {
    try {
      const response = await uploadSliderPictureAPI(file);
      return response.data || response;
    } catch (error) {
      console.error('Error uploading slider picture:', error);
      throw error;
    }
  }
};

export default sliderService;